import { __assign } from "tslib";
import React from 'react';
import { Grid, FormControl, FormLabel, Input, Textarea, Button, FormErrorMessage } from '@chakra-ui/react';
import { useFormik, FormikProvider, Form, Field } from 'formik';
import * as Yup from 'yup';
import { default as NumberFormat } from 'react-number-format';
import { CheckBoxLabel } from "../CheckBoxLabel";
export var AddressForm = function AddressForm(props) {
  var _onSubmit = props.onSubmit,
      initialValues = props.initialValues,
      _a = props.addressType,
      addressType = _a === void 0 ? 'company' : _a,
      _b = props.buttonLabel,
      buttonLabel = _b === void 0 ? 'บันทึก' : _b;
  var defaultValues = {
    primary: false,
    name: '',
    address: '',
    taxId: ''
  };
  var switchLabelByAddress = React.useCallback(function (companyLabel, individualLabel) {
    if (addressType === 'company') {
      return companyLabel;
    }

    return individualLabel;
  }, [addressType]);
  var formik = useFormik({
    initialValues: initialValues || defaultValues,
    onSubmit: function onSubmit(values) {
      _onSubmit(values);
    },
    validationSchema: Yup.object({
      name: Yup.string().required(switchLabelByAddress('จำเป็นต้องใส่ชื่อบริษัท', 'จำเป็นต้องใส่ชื่อ')),
      address: Yup.string().required('จำเป็นต้องใส่ที่อยู่'),
      taxId: Yup.string().required('จำเป็นต้องใส่').length(13, 'เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง')
    })
  });
  return /*#__PURE__*/React.createElement(FormikProvider, {
    value: formik
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
    gap: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "name"
  }, function (_a) {
    var field = _a.field,
        form = _a.form;
    return /*#__PURE__*/React.createElement(FormControl, {
      isInvalid: Boolean(form.errors.name && form.touched.name)
    }, /*#__PURE__*/React.createElement(FormLabel, {
      htmlFor: "name"
    }, switchLabelByAddress('ชื่อบริษัท', 'ชื่อ - นามสกุล')), /*#__PURE__*/React.createElement(Input, __assign({
      id: "name",
      placeholder: switchLabelByAddress('ชื่อบริษัท', 'ชื่อ - นามสกุล')
    }, field)), /*#__PURE__*/React.createElement(FormErrorMessage, null, form.errors.name));
  }), /*#__PURE__*/React.createElement(Field, {
    name: "taxId"
  }, function (_a) {
    var field = _a.field,
        form = _a.form;
    return /*#__PURE__*/React.createElement(FormControl, {
      isInvalid: Boolean(form.errors.taxId && form.touched.taxId)
    }, /*#__PURE__*/React.createElement(FormLabel, {
      htmlFor: "taxId"
    }, "\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35 13 \u0E2B\u0E25\u0E31\u0E01"), /*#__PURE__*/React.createElement(NumberFormat, {
      id: "taxId",
      placeholder: "\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35 13 \u0E2B\u0E25\u0E31\u0E01",
      value: field.value,
      format: "#############",
      customInput: Input,
      onValueChange: function onValueChange(e) {
        form.setFieldValue('taxId', e.value);
      }
    }), /*#__PURE__*/React.createElement(FormErrorMessage, null, form.errors.taxId));
  }), /*#__PURE__*/React.createElement(Field, {
    name: "address"
  }, function (_a) {
    var field = _a.field,
        form = _a.form;
    return /*#__PURE__*/React.createElement(FormControl, {
      isInvalid: Boolean(form.errors.address && form.touched.address)
    }, /*#__PURE__*/React.createElement(FormLabel, {
      htmlFor: "address"
    }, addressType === 'company' ? 'ที่อยู่สำหรับออกใบกำกับภาษีนิติบุคคล' : 'ที่อยู่สำหรับออกใบกำกับภาษีบุคคลธรรมดา'), /*#__PURE__*/React.createElement(Textarea, __assign({
      id: "address",
      placeholder: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35"
    }, field)), /*#__PURE__*/React.createElement(FormErrorMessage, null, form.errors.address));
  }), /*#__PURE__*/React.createElement(Field, {
    name: "primary"
  }, function (_a) {
    var field = _a.field,
        form = _a.form;
    return /*#__PURE__*/React.createElement(CheckBoxLabel, {
      isChecked: field.value,
      onChange: function onChange(checked) {
        return form.setFieldValue('primary', checked);
      }
    }, "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19");
  }), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "solid",
    type: "submit",
    width: "full",
    colorScheme: "brand",
    mt: "2"
  }, buttonLabel))));
};